/*
 * Meet hoe hoog de cookiebanner is en zet dat in --consent-h.
 *
 * Waarom meten en niet een vaste waarde: de hoogte hangt af van de taal, de
 * tekstlengte uit je Shopify-instellingen en de schermbreedte. Een vast getal
 * is op het ene toestel te weinig - dan blokkeert hij alsnog de knop - en op
 * het andere te veel, en dan staat er een gat onder de pagina.
 *
 * De banner komt van Shopify's eigen script en verschijnt ná de pagina, dus
 * één meting bij het laden is te vroeg. Vandaar de observer.
 */
(function () {
  var root = document.documentElement;
  var vorige = -1;

  function zichtbaar(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && el.getBoundingClientRect().height > 0;
  }

  function meet() {
    var b = document.getElementById('shopify-pc__banner');
    var h = zichtbaar(b) ? Math.ceil(b.getBoundingClientRect().height) : 0;
    if (h === vorige) return;            /* niets veranderd: geen herberekening */
    vorige = h;
    root.style.setProperty('--consent-h', h + 'px');
  }

  /* Ook op resize en draaien: de banner wordt hoger zodra de tekst over meer
     regels valt. */
  window.addEventListener('resize', meet, { passive: true });
  window.addEventListener('orientationchange', meet, { passive: true });

  function start() {
    meet();
    var doel = document.body || root;
    try {
      new MutationObserver(meet).observe(doel, {
        childList: true, subtree: true,
        attributes: true, attributeFilter: ['style', 'class', 'hidden'],
      });
    } catch (e) { /* geen observer: de resize-listener en de meting hierboven blijven */ }

    /* Vangnet voor de eerste seconden, waarin Shopify de banner plaatst en
       direct daarna nog kan herschikken. */
    var n = 0;
    var tik = setInterval(function () { meet(); if (++n > 20) clearInterval(tik); }, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
